import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom';

const TakeLookTopSection = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const handleTabClick = (tabName) => {
        // Handle tab navigation
        navigate(`/${tabName}`);
    };


    return (
        <>

            {/* Hero Section */}
            <section className="hero-section">
                <div className="hero-image hero-background">
                    <div className="hero-overlay">
                        <div className="hero-content">
                            <div className="hero-yellow-line"></div>
                            <h1 className="hero-title">둘러보기</h1>
                        </div>
                    </div>
                </div>
            </section>


            {/* Sub Navigation */}
            <section className="sub-navigation">
                <div className="tab-container">
                    <a
                        className={`tab-link ${location.pathname.includes('overall-view') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('overall-view');
                        }}
                    >
                        전체전경
                    </a>
                    <a
                        className={`tab-link ${location.pathname.includes('sky-hall') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('sky-hall');
                        }}
                    >
                        하늘관
                    </a>
                    <a
                        className={`tab-link ${location.pathname.includes('hall-vip') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('hall-vip');
                        }}
                    >
                        하늘관 VIP
                    </a>
                    <a
                        className={`tab-link ${location.pathname.includes('starlight-hall') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('starlight-hall');
                        }}
                    >
                        별빛관
                    </a>

                    <a
                        className={`tab-link ${location.pathname.includes('sunshine-hall') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('sunshine-hall');
                        }}
                    >
                        햇빛관
                    </a>
                    <a
                        className={`tab-link ${location.pathname.includes('s-hall') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('s-hall');
                        }}
                    >
                        S관
                    </a>
                    <a
                        className={`tab-link ${location.pathname.includes('a-hall') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('a-hall');
                        }}
                    >
                        A관
                    </a>
                    <a
                        className={`tab-link ${location.pathname.includes('family-hall') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('family-hall');
                        }}
                    >
                        가족묘
                    </a>
                    <a
                        className={`tab-link ${location.pathname.includes('outdoor-hall') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('outdoor-hall');
                        }}
                    >
                        야외 봉안당
                    </a>
                </div>
            </section>

        </>
    )
}

export default TakeLookTopSection;